import { yupResolver } from "@hookform/resolvers/yup";
import {
  toastrErrorAlert,
  toastrSuccessAlert,
} from "components/Common/AlertToastr";
import { CommonButton } from "components/Common/ButtonCommon";
import HeaderCreateItem from "components/Common/HeaderCreateItem";
import useGetFormSchema from "custom-hook/useGetFormSchema";
import { uploadImg } from "helpers/erp_helper";
import { GET_TRAINING_CATEGORY } from "helpers/url_helper";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useHistory, useParams } from "react-router-dom";
import { Container } from "reactstrap";
import httpService from "services/httpService";
import * as yup from "yup";

export default function NewTrainingCategory() {
  const { id } = useParams();
  const history = useHistory();

  const schema = yup
    .object({
      title: yup.string().required("Vui lòng nhập tiêu đề của bạn!"),
      order: yup.string().required("Vui lòng nhập số thứ tự hiển thị!"),
    })
    .required();

  useEffect(() => {
    getTrainingCategoryDetail();
  }, [id]);

  const {
    handleSubmit,
    formState: { errors },
    ...rest
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(schema),
  });

  const { renderForm, getContent } = useGetFormSchema(
    "TrainingCategory",
    yup,
    rest,
    errors
  );

  const getTrainingCategoryDetail = async () => {
    if (!id) return;

    const res = await httpService.get(`${GET_TRAINING_CATEGORY}/${id}`);

    if (!res) {
      history.replace("/training-category");
      toastrErrorAlert("Training category not found!");
      return;
    }

    const { reset } = rest;
    reset({
      ...res,
    });
    getContent(res);
  };

  const onSubmit = async values => {
    const { createdAt, updatedAt, ...rest } = values;
    const thumbnail = await uploadImg(rest.thumbnail);

    const trainingCategory = {
      ...rest,
      order: Number(rest.order),
      thumbnail,
    };

    if (id) {
      await httpService.put(`${GET_TRAINING_CATEGORY}/${id}`, trainingCategory);
      toastrSuccessAlert("Cập nhật chương trình huấn luyện thành công!");
      return;
    }

    const res = await httpService.post(
      `${GET_TRAINING_CATEGORY}`,
      trainingCategory
    );

    toastrSuccessAlert("Thêm chương trình huấn luyện thành công!");
    history.replace(`/training-category/${res.objectId}`);
  };

  return (
    <div className="page-content">
      <form onSubmit={handleSubmit(onSubmit)}>
        <HeaderCreateItem title={"Chương trình huấn luyện"}>
          <CommonButton level={0} type="submit">
            Save
          </CommonButton>
        </HeaderCreateItem>
        <Container fluid>{renderForm([])}</Container>
      </form>
    </div>
  );
}
